export default function initPlayer() {
	const playerContainer = document.getElementById('player-container');

	if (!playerContainer) {
		// na strance neni kontejner, nic se nacitat nebude
		return;
	}

	SznPlayerLoader.load(['player']).then(() => {
		const sznRichMediaPlayer = window.SznPlayer.singleContentSetup({
			id: 'sklik_partner_acquisition',
			source: {
				src: 'https://v49-a.sdn.cz/v_49/vmd/sklik_partner_acquisition?fl=mdk,4465e6d6|',
				type: 'application/vnd.seznam-cz.spl+json',
			},
		});

		playerContainer.appendChild(sznRichMediaPlayer.getElement());
	});
}
